'use client';

import {useState} from "react";
import {axiosConfig} from "../../../configs/axiosConfig";
import {toast} from "react-hot-toast";

export default function FormSendEmail() {
    const [inboxForm, setInboxForm] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const {value, name} = e.target;
        setInboxForm({...inboxForm, [name]: value})
    }

    const handleSubmit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        axiosConfig.post(`inbox`, inboxForm)
            .then(({data}) => {
                toast.success(data.message);
                setInboxForm({
                    name: "",
                    email: "",
                    subject: "",
                    message: "",
                })
            })
            .catch((error) => {
                toast.error(error.response.data.message);
                console.log(error)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }
    
    return (
        <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-8 shadow-sm transition-all duration-300">
            <div className="space-y-6">
                <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-slate-900 dark:bg-slate-400 rounded-full"></div>
                    <h2 className="text-2xl font-bold text-slate-900 dark:text-white transition-colors duration-300">
                        Send Message
                    </h2>
                </div>

                <form className="space-y-6" onSubmit={handleSubmit}>
                    {/* Name Input */}
                    <div className="space-y-2">
                        <label htmlFor="name" className="block text-sm font-semibold text-slate-700 dark:text-slate-300">
                            Your Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={inboxForm.name}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400 dark:focus:ring-slate-500 transition-all duration-300"
                            placeholder="Enter your full name"
                        />
                    </div>

                    {/* Email Input */}
                    <div className="space-y-2">
                        <label htmlFor="email" className="block text-sm font-semibold text-slate-700 dark:text-slate-300">
                            Email Address
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={inboxForm.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400 dark:focus:ring-slate-500 transition-all duration-300"
                            placeholder="your.email@example.com"
                        />
                    </div>

                    {/* Subject Input */}
                    <div className="space-y-2">
                        <label htmlFor="subject" className="block text-sm font-semibold text-slate-700 dark:text-slate-300">
                            Subject
                        </label>
                        <input
                            type="text"
                            id="subject"
                            name="subject"
                            value={inboxForm.subject}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400 dark:focus:ring-slate-500 transition-all duration-300"
                            placeholder="What's this about?"
                        />
                    </div>

                    {/* Message Textarea */}
                    <div className="space-y-2">
                        <label htmlFor="message" className="block text-sm font-semibold text-slate-700 dark:text-slate-300">
                            Message
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            value={inboxForm.message}
                            onChange={handleChange}
                            required
                            rows={5}
                            className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400 dark:focus:ring-slate-500 transition-all duration-300 resize-none"
                            placeholder="Tell me about your project or idea..."
                        />
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="group w-full bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:hover:bg-white text-white dark:text-slate-900 font-semibold py-4 px-6 rounded-xl transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-sm"
                    >
                        {isLoading ? (
                            <>
                                <svg className="animate-spin w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                <span>Sending...</span>
                            </>
                        ) : (
                            <>
                                <svg className="w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                </svg>
                                <span>Send Message</span>
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    )
}
